import { render, staticRenderFns } from "./ReportDesktopWorkerMonth.vue?vue&type=template&id=5daef4d6"
import script from "./ReportDesktopWorkerMonth.vue?vue&type=script&lang=js"
export * from "./ReportDesktopWorkerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports